import React, { Component } from "react";

import HabitLabel from "./HabitLabel";
import HistorySquare from "./HistorySquare";
import StatSquare from "./StatSquare";

import "./HabitRow.css";

export default class HabitRow extends Component {

  constructor(props) {
    super(props);

    this.fullDaysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    this.handleHover = this.handleHover.bind(this);
    this.updateColor = this.updateColor.bind(this);
    this.addDay = this.addDay.bind(this);
    this.removeDay = this.removeDay.bind(this);
    this.handleDragDrop = this.handleDragDrop.bind(this);

    this.state = {
      isHovered: false,
      habit: this.props.habit
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.habit.habitId != prevState.habit.habitId) {
      this.setState({
        habit: this.props.habit
      });
    }
    if (this.props.habit.color != prevState.habit.color) {
      this.setState({
        habit: this.props.habit
      });
    }
    // if (this.props.habit.marks && prevState.habit.marks) {
    //   if (this.props.habit.marks.values != prevState.habit.marks.values) {
    //     console.log(prevProps.habit.marks);
    //     console.log(prevState.habit.marks);
    //   }
    // }
  }

  handleDragDrop(habitId) {
    this.props.handleDragDrop(habitId);
  }

  handleHover() {
    this.setState({
      isHovered: !this.state.isHovered
    })
  }

  isSameDate(x , y) {
    if (x.getFullYear() === y.getFullYear() &&
        x.getMonth() === y.getMonth() &&
        x.getDate() === y.getDate()) {
          return true;
    }
    return false;
  }

  async updateColor(color) {
    var habit = this.props.habit;
    habit.color = color;
    this.setState({
      habit: habit
    });
  }

  async addDay(day) {
    if (!this.state.habit.marks) {
      this.state.habit.marks = {
        values: [ day ]
      }
    }
    var newMarkedHabit = JSON.parse(JSON.stringify(this.state.habit));
    newMarkedHabit.marks.values.push(day);
    this.setState({
      habit: newMarkedHabit
    });
  }

  async removeDay(day) {
    var newMarkedHabit = JSON.parse(JSON.stringify(this.state.habit));
    var index = newMarkedHabit.marks.values.indexOf(day);
    if (index > -1) {
      newMarkedHabit.marks.values.splice(index, 1);
    }
    this.setState({
      habit: newMarkedHabit
    });
  }

  render() {
    return (
        <tr onMouseEnter={ this.handleHover } onMouseLeave={ this.handleHover }className="HabitRow">
          <HabitLabel
            habit={ this.state.habit }
            updateColor={ this.updateColor }
            handleDrag={ this.props.handleDrag }
            handleDragDrop={ this.handleDragDrop }
            handleHoverMove={this.props.handleHoverMove }
            habitDragged={ this.props.habitDragged }
            isTableHovered={ this.props.isTableHovered }
            mouseIsDown={ this.props.mouseIsDown }
            handleMouse={this.props.handleMouse}
            loadHabits={ this.props.loadHabits }
          >
          </HabitLabel>
          { this.historySquares() }
        </tr>
    );
  }

  historySquares() {
    const OPACITY_INCREMENT = 1 / this.props.numDays;
    const OPACITY_PENALTY = .3;

    var days = this.state.habit.days.values;
    var dayOfWeek = this.fullDaysOfWeek[this.props.startDate.getDay()];
    var result = [];
    var opacity = 0;
    var onStreak = false;
    var previousOpacity = 0.2;

    for (var i = 1; i <= this.props.numDays; i++) {
      var habit = this.state.habit;
      var colDate = new Date(this.props.startDate);
      colDate.setDate(this.props.startDate.getDate() + i);
      var dayOfWeek = this.fullDaysOfWeek[colDate.getDay()];
      var markable = false;
      if (habit.days.values.indexOf(dayOfWeek) > -1) {
        markable = true;
      }

      var marked = false;
      var markDay = getTodayDateString(colDate);
      if (habit.marks && habit.marks.values.indexOf(markDay) > -1) {
        marked = true;
        opacity = previousOpacity + OPACITY_INCREMENT;
        previousOpacity = opacity;
        onStreak = true;
      } else {
        if (!markable && onStreak) {
          marked = true;
          opacity = previousOpacity + OPACITY_INCREMENT;
          previousOpacity = opacity;
        } else if (markable && !marked) {
          onStreak = false;
          opacity = opacity * OPACITY_PENALTY;
          previousOpacity = opacity;
        }
      }

      var isToday = false;
      if (this.isSameDate(new Date(), colDate)) {
        isToday = true;
      }

      if (this.state.isHovered && !isToday) {
        opacity = opacity * .8;
      }

      var colorScheme = "rgba(204, 51, 6, "; // default
      if (this.state.habit.color) {
        colorScheme = this.props.habit.color;
      }

      result.push(
        <HistorySquare
          colorScheme={ colorScheme }
          isToday={ isToday }
          isEditMode={ this.props.isEditMode }
          isRowHovered={ this.state.isHovered }
          opacity={ opacity }
          marked={ marked }
          markable={ markable }
          date={ colDate }
          habitId={ this.state.habit.habitId }
          loadHabits={ this.props.loadHabits }
          addDay={ this.addDay }
          removeDay={ this.removeDay }
        ></HistorySquare>
      );
    }
    return result;
  }
}

function getTodayDateString(dateObj) {
  var year = dateObj.getFullYear();
  var date = dateObj.getDate().pad(2);
  var month = (dateObj.getMonth() + 1).pad(2);
  return Number(year.toString() + month + date.toString());
}



// WEBPACK FOOTER //
// ./src/containers/HabitRow.js